<template>
  <va-edit-layout :title="title">
    <segmentations-form :id="id" :item="item"></segmentations-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
